(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
(() => {
  const states = new WeakMap();
  const status = (offer, message, error = false) => {
    const element = offer.querySelector('[data-newsletter-status]');
    element.textContent = message;
    element.hidden = false;
    element.dataset.error = String(error);
  };
  const busy = (offer, enabled) => {
    offer.setAttribute('aria-busy', String(enabled));
    offer.querySelectorAll('button, [data-newsletter-apply]').forEach(element => {
      if (element.tagName === 'BUTTON') element.disabled = enabled;
      element.setAttribute('aria-disabled', String(enabled));
    });
  };
  const applyDiscount = async (offer) => {
    busy(offer, true);
    status(offer, offer.dataset.working);
    try {
      const section = offer.closest('[data-cart-wrapper]');
      const sectionId = section.dataset.section;
      const root = offer.dataset.root;
      const response = await fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) throw new Error();
      const current = await response.json();
      const applications = [...(current.cart_level_discount_applications || [])];
      (current.items || []).forEach(item => (item.line_level_discount_allocations || []).forEach(allocation => applications.push(allocation.discount_application)));
      const codes = applications.filter(application => application && application.type === 'discount_code').map(application => application.title);
      codes.push(offer.dataset.code);
      const note = section.querySelector('[data-cart-note]')?.value;
      const updateResponse = await fetch(root + 'cart/update.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: [...new Set(codes)].join(',') })
      });
      if (!updateResponse.ok) throw new Error();
      const updated = await updateResponse.json();
      const sectionResponse = await fetch(offer.dataset.cartUrl + '?section_id=' + encodeURIComponent(sectionId), { credentials: 'same-origin', cache: 'no-store' });
      if (!sectionResponse.ok) throw new Error();
      const html = await sectionResponse.text();
      updated.sections = { [sectionId]: html };
      const fresh = new DOMParser().parseFromString(html, 'text/html');
      const refreshedOffer = fresh.querySelector('[data-tulora-newsletter]');
      if (!refreshedOffer || !refreshedOffer.querySelector('.tulora-cart-newsletter__success')) throw new Error();
      if (typeof window.cartContentUpdate === 'function') {
        window.cartContentUpdate(updated, section, sectionId);
      } else {
        section.querySelector('[data-cart-prices]').innerHTML = fresh.querySelector('[data-cart-prices]').innerHTML;
      }
      if (note !== undefined) {
        const noteInput = section.querySelector('[data-cart-note]');
        if (noteInput) noteInput.value = note;
      }
      offer.innerHTML = refreshedOffer.innerHTML;
      const success = offer.querySelector('.tulora-cart-newsletter__success');
      success.tabIndex = -1;
      success.focus({ preventScroll: true });
    } catch {
      status(offer, offer.dataset.discountError, true);
    } finally {
      busy(offer, false);
    }
  };
  const enableSignup = () => document.querySelectorAll('[data-newsletter-signup] button[type="submit"]').forEach(button => { button.disabled = false; });
  enableSignup();
  document.addEventListener('shopify:section:load', enableSignup);
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!form.matches('[data-newsletter-signup]')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const offer = form.closest('[data-tulora-newsletter]');
    let state = states.get(form);
    if (!state) {
      state = { pending: false, subscribed: false };
      states.set(form, state);
    }
    if (state.pending) return;
    state.pending = true;
    busy(offer, true);
    status(offer, offer.dataset.working);
    try {
      if (!state.subscribed) {
        const email = form.querySelector('input[type="email"]').value.trim();
        if (!offer.dataset.klaviyoSite || !offer.dataset.klaviyoList) throw new Error();
        const response = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(offer.dataset.klaviyoSite), {
          method: 'POST',
          signal: AbortSignal.timeout(15000),
          headers: { 'Content-Type': 'application/vnd.api+json', revision: '2026-07-15' },
          body: JSON.stringify({ data: {
            type: 'subscription',
            attributes: { custom_source: 'Tulora cart newsletter 10% offer', profile: { data: { type: 'profile', attributes: { email } } } },
            relationships: { list: { data: { type: 'list', id: offer.dataset.klaviyoList } } }
          } })
        });
        if (!response.ok) throw new Error();
        state.subscribed = true;
        window.klaviyo = window.klaviyo || [];
        window.klaviyo.push(['identify', { email }]);
      }
      await applyDiscount(offer);
    } catch {
      status(offer, offer.dataset.error, true);
    } finally {
      state.pending = false;
      busy(offer, false);
    }
  }, true);
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-newsletter-apply]');
    if (!link) return;
    event.preventDefault();
    if (link.getAttribute('aria-disabled') !== 'true') applyDiscount(link.closest('[data-tulora-newsletter]'));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["you-me-ring"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('tulora-gift-addon')) {
  customElements.define('tulora-gift-addon', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.optIn = this.querySelector('[data-gift-opt-in]');
      this.details = this.querySelector('[data-gift-details]');
      this.variant = this.querySelector('[data-gift-variant]');
      this.count = this.querySelector('[data-gift-count]');
      this.addEventListener('change', event => {
        if (event.target !== this.querySelector('[data-gift-confirm]')) this.querySelector('[data-gift-confirm]').checked = false;
        this.sync();
      });
      this.sync();
    }
    sync() {
      const option = this.variant.selectedOptions[0];
      const available = option && option.dataset.available === 'true' && this.dataset.sellingPlan !== 'true';
      this.optIn.disabled = !available;
      if (!available) this.optIn.checked = false;
      this.details.hidden = !this.optIn.checked;
      this.querySelector('[data-gift-price]').textContent = option ? option.dataset.money : '';
      const active = this.optIn.checked && !this.closest('[data-bundle-extra][hidden]');
      this.querySelectorAll('[data-gift-charm]').forEach((row,index) => { row.hidden = this.count ? index >= Number(this.count.value) : false; });
      this.details.querySelectorAll('select,input').forEach(control => {
        const visible = !control.closest('[data-gift-charm][hidden]');
        control.disabled = !active || !visible;
        control.required = active && visible;
      });
    }
    get priceCents() {
      return this.optIn.checked ? Number(this.variant.selectedOptions[0].dataset.cents) * Number(this.dataset.quantity || 1) : 0;
    }
    getCartItems() {
      if (!this.optIn.checked) return [];
      this.sync();
      for (const control of this.details.querySelectorAll('select,input')) {
        if (!control.reportValidity()) return null;
      }
      const properties = {};
      if (this.dataset.giftType === 'ring') {
        this.querySelectorAll('[data-gift-month]').forEach((select,index) => { properties['Birthstone ' + (index+1)] = select.value; });
      } else {
        properties['Number of charms'] = this.count.value;
        properties.Material = this.variant.selectedOptions[0].textContent.trim();
        this.querySelectorAll('[data-gift-charm]').forEach((row,index) => {
          if (!row.hidden) properties['Charm ' + (index+1)] = row.querySelector('[data-gift-kind]').value + ' — ' + row.querySelector('[data-gift-month]').value;
        });
        properties._tulora_necklace = 'gift-addon';
      }
      return [{id:Number(this.variant.value),quantity:Number(this.dataset.quantity || 1),properties}];
    }
  });
}

if (!customElements.get('you-me-ring')) {
  customElements.define('you-me-ring', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.form = this.querySelector('.ymr__form');
      if (!this.form) return;
      this.button = this.querySelector('[data-atc]');
      this.message = this.querySelector('[data-error-message]');
      this.busy = false;
      this.setAttribute('data-enhanced', '');
      this.form.addEventListener('change', event => {
        if (event.target.matches('input[type="radio"]')) this.updatePairing();
        this.updateVariant();
        this.message.hidden = true;
      }, options);
      this.querySelectorAll('[data-gallery-image]').forEach(link => {
        link.addEventListener('click', event => {
          event.preventDefault();
          const hero = this.querySelector('.ymr__main-image');
          if (!hero) return;
          hero.srcset = link.dataset.srcset;
          hero.src = link.dataset.src;
          hero.alt = link.dataset.alt;
          this.querySelectorAll('[data-gallery-image]').forEach(item => item.setAttribute('aria-current', String(item === link)));
        }, options);
      });
      this.form.addEventListener('submit', event => this.submit(event), options);
      window.addEventListener('pageshow', () => this.reset(), options);
      this.updatePairing();
      this.updateVariant();
    }
    disconnectedCallback() {
      if (this.controller) this.controller.abort();
      if (this.request) this.request.abort();
    }
    updatePairing() {
      this.querySelectorAll('[data-person]').forEach(fieldset => {
        const selection = fieldset.querySelector('input:checked');
        const index = fieldset.dataset.person;
        fieldset.querySelector('[data-chosen]').textContent = selection ? selection.dataset.month : this.dataset.empty;
        const summary = this.querySelector(`[data-summary="${index}"]`);
        if (!summary.dataset.initial) summary.dataset.initial = summary.textContent;
        summary.textContent = selection ? selection.dataset.month : summary.dataset.initial;
        this.querySelector(`[data-pair-gem="${index}"]`).style.setProperty('--stone', selection ? selection.dataset.color : '#d7d1c7');
      });
    }
    updateVariant() {
      const select = this.querySelector('[data-variant-select]');
      const variant = select ? select.selectedOptions[0] : null;
      const price = this.querySelector('[data-price]');
      const compare = this.querySelector('[data-compare]');
      if (price && variant) price.textContent = variant.dataset.price;
      if (compare && variant) {
        compare.textContent = variant.dataset.compare;
        compare.hidden = !variant.dataset.compare;
      }
      const label = this.querySelector('[data-button-label]');
      const bundle = this.querySelector('[data-bundle]:checked');
      const quantity = bundle ? Number(bundle.dataset.quantity) : 1;
      const second = this.querySelector('[data-second-variant]');
      const secondVariant = second ? second.selectedOptions[0] : null;
      const secondWrap = this.querySelector('[data-second-ring]');
      if (secondWrap) secondWrap.hidden = quantity < 2;
      const available = (variant ? variant.dataset.available : this.dataset.available) === 'true' && (quantity < 2 || !secondVariant || secondVariant.dataset.available === 'true');
      this.button.disabled = this.busy || !available || !this.querySelector('.ymr__stone');
      label.textContent = available ? label.dataset.default : label.dataset.soldOut;
      const primaryPrice = Number(variant ? variant.dataset.cents : this.dataset.priceCents);
      const secondPrice = secondVariant ? Number(secondVariant.dataset.cents) : primaryPrice;
      this.querySelectorAll('[data-bundle]').forEach(option => {
        const amount = primaryPrice + (Number(option.dataset.quantity) > 1 ? secondPrice : 0);
        this.querySelector(`[data-bundle-price="${option.value}"]`).textContent = this.money(amount);
      });
      let total = primaryPrice + (quantity > 1 ? secondPrice : 0);
      this.querySelectorAll('[data-bundle-extra]').forEach(panel => {
        panel.hidden = !bundle || panel.dataset.bundleExtra !== bundle.value;
        const addon = panel.querySelector('tulora-gift-addon');
        if (addon && addon.ready) { addon.sync(); if (!panel.hidden) total += addon.priceCents; }
      });
      const subtotal = this.querySelector('[data-total]');
      if (subtotal) subtotal.textContent = this.money(total);
      this.updateStock(variant);
    }
    updateStock(variant) {
      const line = this.querySelector('[data-ring-stock]');
      if (!line) return;
      const data = variant ? variant.dataset : this.dataset;
      const tracked = Boolean(data.stockManagement);
      const quantity = Number(data.stockQuantity);
      const number = input => { const text = (input || '').trim().replace(/,/g, ''); return /^\d+$/.test(text) && Number.isSafeInteger(Number(text)) ? Number(text) : null; };
      const confirmedStock = number(line.dataset.confirmedStock);
      const confirmedSold = number(line.dataset.confirmedSold);
      const format = value => value.toLocaleString(this.dataset.locale || 'en');
      let label = this.dataset.stockLabel;
      if (data.available !== 'true') label = this.querySelector('[data-button-label]').dataset.soldOut;
      else if (tracked && quantity > 0) label = this.dataset.stockCount.replace('{count}', format(quantity));
      else if (tracked) label = this.dataset.stockOrder;
      else if (confirmedStock !== null) label = this.dataset.stockCount.replace('{count}', format(confirmedStock));
      if (confirmedSold > 0) label += ' / ' + this.dataset.stockSold.replace('{count}', format(confirmedSold));
      line.querySelector('[data-stock-text]').textContent = label;
    }
    money(cents) {
      return new Intl.NumberFormat(this.dataset.locale || 'en', { style: 'currency', currency: this.dataset.currency || 'USD' }).format(cents / 100);
    }
    reset() {
      this.busy = false;
      if (this.button) {
        this.button.removeAttribute('aria-busy');
        this.updateVariant();
      }
    }
    async submit(event) {
      event.preventDefault();
      if (this.busy || this.button.disabled) return;
      if (!this.form.reportValidity()) return;
      if (this.dataset.designMode === 'true') {
        this.message.textContent = this.dataset.preview;
        this.message.hidden = false;
        return;
      }
      const payload = new FormData(this.form);
      const bundle = this.querySelector('[data-bundle]:checked');
      const quantity = bundle ? Number(bundle.dataset.quantity) : 1;
      const properties = {};
      for (const [key, value] of payload.entries()) {
        const match = key.match(/^properties\[(.+)\]$/);
        if (match) properties[match[1]] = value;
      }
      if (bundle) properties.Bundle = bundle.dataset.title;
      const items = [{ id: Number(payload.get('id')), quantity, properties }];
      const second = this.querySelector('[data-second-variant]');
      if (quantity > 1 && second && second.value !== payload.get('id')) {
        items[0].quantity = 1;
        items.push({ id: Number(second.value), quantity: 1, properties: { ...properties } });
      }
      const panel = bundle ? this.querySelector(`[data-bundle-extra="${bundle.value}"]`) : null;
      const addon = panel?.querySelector('tulora-gift-addon');
      if (addon) {
        const extras = addon.getCartItems();
        if (!extras) return;
        items.push(...extras);
      }
      this.busy = true;
      this.button.disabled = true;
      this.button.setAttribute('aria-busy', 'true');
      this.message.hidden = true;
      this.request = new AbortController();
      let navigating = false;
      try {
        const response = await fetch(this.form.action.replace(/\/add\/?$/, '/add.js'), {
          method: 'POST', body: JSON.stringify({ items }), signal: this.request.signal,
          headers: { Accept: 'application/json', 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
        });
        const result = await response.json();
        if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : this.dataset.error);
        const discount = bundle ? bundle.dataset.discount.trim() : '';
        const root = this.dataset.root.endsWith('/') ? this.dataset.root : this.dataset.root + '/';
        const destination = discount ? root + 'discount/' + encodeURIComponent(discount) + '?redirect=' + encodeURIComponent(this.dataset.cartUrl) : this.dataset.cartUrl;
        navigating = true;
        window.location.assign(destination);
      } catch (error) {
        if (error.name !== 'AbortError') {
          this.message.textContent = error.message === 'Failed to fetch' ? this.dataset.error : error.message;
          this.message.hidden = false;
        }
      } finally {
        if (!navigating) this.reset();
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
